import {GenEventResultGroup} from '../../../../../generated/serverModels/GenEventResultGroup';
import bboxPolygon from '@turf/bbox-polygon';

export class HeadoutEventResult extends GenEventResultGroup {
    public geometry: any;
    public extra: any;

    constructor(result?: HeadoutEventResult) {
        super(result);
        if (result) {
            try {
                this.geometry = bboxPolygon(result.boundary as any).geometry;
            } catch (error) {
                console.error('unable to create geometry for event result: ' + result.anlId);
            }
        }
    }
}
